import React from 'react';
import { createRoot } from 'react-dom/client';
import { i18n, init as i18nInit } from 'src/i18n';
import { AuthToken } from './modules/auth/authToken';
import TenantService from './modules/tenant/tenantService';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import config from 'src/config';
import queryString from 'query-string';
import { ThemeProvider } from './theme/ThemeContext';
import DataDogErrorBoundary from 'src/datadog/DataDogErrorBoundary';

import { unstableSetRender } from 'antd/lib/config-provider/UnstableContext';

// TODO: remove this when antd is updated to SUPPORT REACT 19
unstableSetRender((node, container) => {
  //@ts-ignore
  container._reactRoot ||= createRoot(container);
  //@ts-ignore
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise(resolve => setTimeout(resolve, 0));
    root.unmount();
  };
});

(async function () {
  AuthToken.applyFromLocationUrlIfExists();
  await TenantService.fetchAndApply();

  const queryParams = queryString.parse(window.location.search);

  await i18nInit(queryParams?.lang as string);

  const isPublicView = window.location.href.includes(
    `${config.eLabelPublicUrl.host}${config.eLabelPublicUrl.path}`,
  );

  document.title = i18n('app.title');

  const App = (
    isPublicView
      ? await import('./public-elabel/PublicElabelApp')
      : await import('./App')
  ).default;

  const currentSettings = AuthCurrentTenant.getSettings();
  const container = document.getElementById('root');
  const root = createRoot(container as Element);

  root.render(
    <ThemeProvider initTheme={currentSettings?.theme}>
      <DataDogErrorBoundary>
        <App />
      </DataDogErrorBoundary>
    </ThemeProvider>,
  );
})();
